// O tema esconde a seta de todo select (form/select.ts); sem fundo e seta, o "linhas por página" parecia texto.
const tablePagination = {
    styleOverrides: {
        input: {
            marginLeft: 8,
            marginRight: 16,
            borderRadius: 6,
            backgroundColor: "rgba(255, 255, 255, 0.08)",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.14)" },
            "& .MuiSelect-icon": { display: "inline-block", right: 2 },
        },
        select: {
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 10,
        },
    },
};

export default tablePagination;
